import * as React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ActionsCreators } from "../../../actions";
import CallLog from "./CallLog";

class CallLogContainer extends React.Component {
    constructor() {
        super();
        this.state = {
            reload: new URLSearchParams(window.location.search).get("reload"),
            reloadKey: 0
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.location.search !== this.props.location.search) {
            const reload = new URLSearchParams(this.props.location.search).get("reload");
            if (reload && reload !== this.state.reload) {
                this.setState((prev) => ({
                    reload,
                    reloadKey: prev.reloadKey + 1
                }));
            }
        }
    }

    render() {
        return (
            <CallLog
                {...this.props}
                reload={this.state.reload}
                key={`callLog-${this.state.reloadKey}`}
            />
        );
    }
}

const mapDispatchToProps = (dispatch) => bindActionCreators(ActionsCreators, dispatch);

export default withRouter(connect(
    (state) => state,
    mapDispatchToProps
)(CallLogContainer));
